import { render } from "./ResourcesCard.vue?vue&type=template&id=03660f8e"
import script from "./ResourcesCard.vue?vue&type=script&lang=js"
export * from "./ResourcesCard.vue?vue&type=script&lang=js"

import "./ResourcesCard.vue?vue&type=style&index=0&id=03660f8e&lang=scss"
script.render = render

export default script